<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import {
  getList,
  getConfig,
  createBill,
  detail,
  income_details,
  saveCost,
  saveCosts,
  getIdAgent,
  send_fee,
  addRemark,
  unpack_order,
  create_send_bill,
  clearance_fee,
  task,
} from "@/api/finance/summary_ship_details_new";
import { getSubjectCost } from "@/api/tracker/cost_page";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";
// import { getWarehouse } from "@/api/storage/warehouse";
import cTable from "@/base/common/index";
import { getAgent } from "@/api/tracker/agent";
import { getSelectType } from "@/api/public";
import { getCurrency } from "@/api/finance/currency";
export default {
  name: "summary_ship_details",
  components: {
    cTable,
  },
  data() {
    let redKeys = ["cost107", "send_fee", "pod_send_fee"];
    redKeys.push(
      ...Array(11)
        .fill(1)
        .map((t, i) => "cost" + (i + 1))
    );
    return {
      methods: {
        list: (p) => getList(p),
        getAllClient,
        createBill,
        detail,
        income_details,
        getCountry,
        saveCost,
        saveCosts,
        getIdAgent,
        send_fee,
        addRemark,
        unpack_order,
        create_send_bill,
        clearance_fee,
        task,
      },
      config: {
        cellClassName({ row, rowIndex, column, columnIndex }) {
          if (redKeys.includes(column.property)) {
            if (row[column.property + "_bill"]) {
              return "col-red";
            }
          }
        },
      },
      modals: {
        export: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("list", row, false, true)
                .then(async (res) => {
                  this.$page.toast(res.msg);
                  close();
                });
            },
          },
          config: {
            title: this.$t("export"),
            modalBind: {
              width: 500,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ title: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("zhTitle"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("zhTitle");
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
        exportList: {
          config: {
            listFn: "task",
            title: this.$t("exportRecords"),
            modalBind: {
              width: 1000,
              draggable: true,
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            footer: {
              show: () => true,
            },
            header: {
              searchs: [
                {
                  key: "startTime",
                  component: "DatePicker",
                  placeholder() {
                    return (
                      this.$t("select") + this.$t("start") + this.$t("time")
                    );
                  },
                  bind: {
                    type: "date",
                    options: {
                      disabledDate(time) {
                        return time.getTime() > Date.now();
                      },
                    },
                    style: {
                      width: "175px",
                    },
                  },
                  methods: {
                    format({ searchForm, value, newFormData }) {
                      return value
                        ? this.format.dateFormat(value, "YYYY-MM-DD")
                        : "";
                    },
                  },
                },
                {
                  key: "endTime",
                  component: "DatePicker",
                  placeholder() {
                    return this.$t("select") + this.$t("end") + this.$t("time");
                  },
                  bind: {
                    type: "date",
                    options: {
                      disabledDate(time) {
                        return time.getTime() > Date.now();
                      },
                    },
                    style: {
                      width: "175px",
                    },
                  },
                  methods: {
                    format({ searchForm, value, newFormData }) {
                      return value
                        ? this.format.dateFormat(value, "YYYY-MM-DD")
                        : "";
                    },
                  },
                },
                {
                  key: "type",
                  placeholder() {
                    return this.$t("select") + this.$t("type");
                  },
                  clearable: false,
                  component: "Select",
                  options: [],
                  methods: {
                    async list({ field, searchForm }) {
                      field.options = await this.$sel.getData(
                        "COST_EXPORT_TYPE"
                      );
                    },
                  },
                },
                {
                  key: "status",
                  placeholder() {
                    return this.$t("select") + this.$t("exlType");
                  },
                  clearable: false,
                  component: "Select",
                  options: [],
                  methods: {
                    async list({ field, searchForm }) {
                      field.options = await this.$sel.getData(
                        "COST_EXPORT_STATUS"
                      );
                    },
                  },
                },
              ],
            },
            fields: [
              {
                name: () => this.$t("zhTitle"),
                key: "title",
                minWidth: 100,
              },
              {
                name: () => this.$t("type"),
                key: "type_name",
                minWidth: 100,
              },
              {
                name: () => this.$t("exlType"),
                key: "status_name",
                minWidth: 100,
              },
              {
                name: () => this.$t("ElapsedTime"),
                key: "take_up_time",
                minWidth: 100,
              },
              {
                name: () => this.$t("error_mes"),
                key: "msg",
                minWidth: 100,
              },
              {
                name: () => this.$t("Remarks"),
                key: "remarks",
                minWidth: 100,
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                minWidth: 150,
              },
              {
                name: () => this.$t("operation"),
                key: "src",
                minWidth: 100,
                render(h, p) {
                  return h(
                    "Button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          window.open(this.$globalUrl + p.row.src);
                        },
                      },
                    },
                    this.$t("download")
                  );
                },
              },
            ],
          },
        },
        clearance: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(
                  "clearance_fee",
                  { packing_number: row.packing_number.split("\n") },
                  true
                )
                .then(async (res) => {
                  close();
                });
            },
          },
          config: {
            title: this.$t("Sync") + this.$t("clearanceFee"),
            modalBind: {
              width: 500,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                  type: "string",
                },
              ],
            },
          },
          grid: [{ packing_number: 24 }],
          fields: [
            {
              name: () => this.$t("packing_number"),
              key: "packing_number",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("packing_number");
              },
            },
          ],
        },
        cost: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("saveCosts", row, true)
                .then(async (res) => {
                  if (this.update) {
                    this.$page.getModal("detail").list = (
                      await detail(this.id)
                    ).data.payload.rows;
                  }
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              agent_id: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                  type: "number",
                },
              ],
              expense_item: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                  type: "array",
                },
              ],
              currency: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                },
              ],
              amount: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "blur",
                  type: "number",
                },
              ],
              bill_number: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { agent_id: 24 },
            { expense_item: 24 },
            { currency: 24 },
            { amount: 24 },
            { bill_number: 24 },
            { type: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("agentT"),
              key: "agent_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("agentT");
              },
              options: [],
              methods: {
                async list({ field, row }) {
                  field.options = (
                    await getIdAgent(this.$modal.id)
                  ).data.payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("expense"),
              key: "expense_item",
              component: "Cascader",
              placeholder() {
                return this.$t("select") + this.$t("expense");
              },
              options: [],
              default: [],
              methods: {
                async list({ field, row }) {
                  field.options = (
                    await getSubjectCost({ pid: 0 })
                  ).data.payload;
                  this.$forceUpdate();
                },
                async loadData({ item, callback }) {
                  console.log(arguments);
                  item.loading = true;
                  item.children = (
                    await getSubjectCost({ pid: item.value })
                  ).data.payload;
                  item.loading = false;
                  callback();
                },
              },
            },
            {
              name: () => this.$t("calculation") + this.$t("currency_t"),
              key: "currency",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("calculation") +
                  this.$t("currency_t")
                );
              },
              config: {
                label: "code",
                value: "code",
              },
              options: [],
              methods: {
                async list({ field, row }) {
                  field.options = (
                    await getCurrency({ pageSize: 9999 })
                  ).data.payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("Rule"),
              key: "type",
              component: "Select",
              clearable: false,
              placeholder() {
                return this.$t("select") + this.$t("Rule");
              },
              default: 1,
              options: [
                { value: 1, label: this.$t("Single") },
                { value: 2, label: this.$t("AmountBetween") },
                { value: 3, label: this.$t("ChargingReassignment") },
              ],
            },
            {
              name: () => this.$t("Billing") + this.$t("reChAmount"),
              key: "amount",
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              default: null,
              placeholder() {
                return (
                  this.$t("enter") + this.$t("Billing") + this.$t("reChAmount")
                );
              },
            },
            {
              name: () => this.$t("bill_number"),
              key: "bill_number",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bill_number");
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
        uploadMsg: {
          config: {
            title: this.$t("updateFile") + this.$t("error_mes"),
            modalBind: {
              width: 500,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("error_mes"),
                key: "msg",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        unpack_order: {
          config: {
            title: this.$t("unpack") + this.$t("detail"),
            modalBind: {
              width: 1000,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("orderNum"),
                key: "airway_number",
                minWidth: 150,
              },
              {
                name: () => this.$t("distribution_agent"),
                key: "deliver",
                minWidth: 130,
              },
              {
                name: () => this.$t("tracker_code"),
                key: "status",
                minWidth: 100,
              },
              {
                name: () => this.$t("check_weight"),
                key: "check_weight",
                minWidth: 100,
              },
              {
                name: () => this.$t("charge_params1"),
                key: "actual_weight",
                minWidth: 100,
              },
              {
                name: () => this.$t("noofpieces"),
                key: "quantity",
                minWidth: 100,
              },
              {
                name: () => this.$t("charge_volume"),
                key: "charge_volume",
                minWidth: 100,
              },
              {
                name: () => this.$t("DeclaredValue"),
                key: "values",
                minWidth: 100,
              },
            ],
          },
        },
        detail: {
          config: {
            listFn: "detail",
            modalBind: {
              width: 80,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: {
            show: () => false,
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("costEntry"),
                type: "cost",
                fnName: "costFun",
                bind: {
                  type: "primary",
                  style: { marginLeft: "10px" },
                },
                id: 1187,
                show() {
                  return !this.params.income;
                },
              },
            ],
            methods: {
              costFun({ searchForm }) {
                this.$page.getModal("cost").id =
                  this.$page.getModal("detail").id;
                this.$page.getModal("cost").update = true;
                this.$page
                  .getModal("cost")
                  .open(
                    { ids: [this.$page.getModal("detail").id] },
                    function () {
                      this.setTitle("costEntry");
                    }
                  );
              },
            },
          },
          table: {
            config: {
              height: 700,
            },

            footer: {
              show: () => false,
              render: (h, r) => {
                let table = this.$refs["table"];
                return h(
                  "div",
                  { style: "text-align:right" },
                  Object.keys(table.temp).map((t) =>
                    h("span", { style: "margin-left:10px" }, [
                      h("span", {}, t + ":"),
                      h("span", { style: "color:red" }, table.temp[t]),
                    ])
                  )
                );
              },
            },
            fields: [
              {
                name: () => this.$t("costCategories"),
                key: "classify",
                minWidth: 100,
                show() {
                  return !this.$modal.params.income;
                },
              },
              {
                name: () => this.$t("costSuject"),
                key: "expense_item",
                minWidth: 100,
              },
              {
                name: () => this.$t("agentT"),
                key: "agent",
                minWidth: 100,
                show() {
                  return !this.$modal.params.income;
                },
              },
              {
                name: () => this.$t("reChAmount"),
                key: "amount",
                minWidth: 100,
              },
              {
                name: () => this.$t("currency_t"),
                key: "currency",
                width: 100,
              },
              {
                name: () => this.$t("to") + this.$t("to_rmb") + this.$t("rate"),
                key: "to_rate",
                minWidth: 80,
              },
              {
                name: () =>
                  this.$t("to") + this.$t("to_rmb") + this.$t("reChAmount"),
                key: "to_amount",
                minWidth: 80,
              },
              {
                name: () => this.$t("Remarks"),
                key: "remarks",
                minWidth: 80,
              },
              {
                name: () => this.$t("operate"),
                key: "create_name",
                minWidth: 80,
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                minWidth: 80,
              },
            ],
          },
        },
        remark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(async (res) => {
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                  type: "string",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            config: {
              label({ row, field }) {
                return this.$t(row.label);
              },
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["SUMMARY_TIME_TYPE"])).data
                  .payload["SUMMARY_TIME_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("time");
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("time");
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            config: {
              value: "id",
              label: "account",
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAllClient")
                ).payload.rows;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            component: "Select",
            config: {
              value: "code",
              label: "title",
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getCountry")
                ).payload.rows;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "business",
            placeholder() {
              return this.$t("select") + this.$t("business");
            },
            component: "Select",
            options: [],
          },
          // {
          //   key: "agentType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("agentName") + this.$t("type");
          //   },
          //   clearable: false,
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getSelectType(["SUMMARY_AGENT_TYPE"])).data
          //         .payload["SUMMARY_AGENT_TYPE"];
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          {
            key: "agent_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "id" },
          },
          {
            key: "department",
            placeholder() {
              return this.$t("select") + this.$t("assistDepartment");
            },
            clearable: true,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["OUTBOUND_COST_DEPARTMENT"]))
                  .data.payload["OUTBOUND_COST_DEPARTMENT"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "type",
            placeholder() {
              return this.$t("select") + this.$t("type");
            },
            clearable: true,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["OUTBOUND_COST_DATA_TYPE"]))
                  .data.payload["OUTBOUND_COST_DATA_TYPE"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["SUMMARY_KEYWORDS_TYPE"])).data
                  .payload["SUMMARY_KEYWORDS_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
          // {
          //   key: "warehouse_id",
          //   placeholder() {
          //     return this.$t("select") + this.$t("warehouseName");
          //   },
          //   component: "Select",
          //   config: {
          //     value: "id",
          //     label: "title"
          //   },
          //   methods: {
          //     async list({ field }) {
          //       field.options = (
          //         await this.$page.handleRequestMethods("getWarehouse")
          //       ).payload.rows;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          // {
          //   key: "date",
          //   component: "DatePicker",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date");
          //   },
          //   bind: {
          //     type: "month",
          //     options: {
          //       disabledDate(time) {
          //         return time.getTime() > Date.now();
          //       }
          //     },
          //     style: {
          //       width: "175px"
          //     }
          //   },
          //   methods: {
          //     format({ value, newFormData }) {
          //       newFormData.temp = 1;
          //       return value ? this.format.monthFormat(value) : "";
          //     }
          //   }
          // },
          // {
          //   key: "endTime",
          //   component: "DatePicker",
          //   placeholder() {
          //     return (
          //       this.$t("select") + this.$t("Billing") + this.$t("endTime")
          //     );
          //   },
          //   bind: {
          //     type: "date",
          //     options: {
          //       disabledDate(time) {
          //         return time.getTime() > Date.now();
          //       }
          //     },
          //     style: {
          //       width: "175px"
          //     }
          //   }
          // },
          // {
          //   key: "dateType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("timeType");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row, field }) {
          //       return this.$t("Billing") + this.$t(row.label);
          //     }
          //   },
          //   options: [
          //     { label: "startTime", value: 1 },
          //     { label: "endTime", value: 5 }
          //   ]
          // },
          // {
          //   key: "reason_billing",
          //   placeholder() {
          //     return this.$t("select") + this.$t("reason_billing");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row, field }) {
          //       return this.$t(row.label);
          //     }
          //   },
          //   options: options
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              // disabled() {
              //   return !this.selectAll.length;
              // },
            },
            {
              name: () => this.$t("exportRecords"),
              type: "exportList",
              fnName: "exportList",
              bind: {
                type: "primary",
              },
            },
            // {
            //   name: () => this.$t("createBill"),
            //   type: "createBill",
            //   fnName: "createBill",
            //   bind: {
            //     icon: "md-add",
            //     type: "warning",
            //   },
            //   id: 1036,
            // },
            // {
            //   name: () => this.$t("createDeliveryBill"),
            //   type: "create_send_bill",
            //   btnBind: {
            //     type: "warning",
            //   },
            // 	id:1203,
            // 	list:[
            // 		{
            // 			name:this.$t('unapod'),
            // 			type:'unapod',
            // 			data:1,
            // 			fnName: "create_send_bill",
            // 		},
            // 		{
            // 			name:this.$t('apod'),
            // 			type:'apod',
            // 			data:2,
            // 			fnName: "create_send_bill",
            // 		}
            // 	]
            // },
            // {
            //   name: () => this.$t("syncDeliveryFee"),
            //   type: "syncDeliveryFee",
            //   fnName: "syncDeliveryFee",
            //   bind: {
            //     type: "warning",
            //   },
            //   id: 1239,
            // },
            {
              name: () => this.$t("costEntry"),
              type: "cost",
              fnName: "costFun",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
              id: 1187,
            },
            // {
            //   name: () => this.$t('Sync') + this.$t("clearanceFee"),
            //   type: "syncClearance",
            //   fnName: "syncClearance",
            //   bind: {
            //     type: "primary",
            //   },
            //   id: 1240,
            // },
          ],
          methods: {
            syncClearance() {
              this.getModal("clearance").open();
            },
            create_send_bill({ searchForm, field }) {
              this.handleRequestMethods(
                "create_send_bill",
                { ...searchForm, type: field.data },
                false,
                true
              ).then((res) => {
                this.$Message.success({
                  background: true,
                  content: res.message || res.msg || "success",
                  duration: 5,
                });
              });
            },
            syncDeliveryFee({ searchForm }) {
              this.handleRequestMethods(
                "send_fee",
                searchForm,
                false,
                true
              ).then((res) => {
                this.$Message.success({
                  background: true,
                  content: res.message || res.msg || "success",
                  duration: 5,
                });
              });
            },
            createBill({ searchForm }) {
              this.handleRequestMethods(
                "createBill",
                searchForm,
                false,
                true
              ).then((res) => {
                if (res.payload.length) {
                  this.getModal("uploadMsg").open(null, function () {
                    this.list = res.payload;
                  });
                } else {
                  this.$Message.success({
                    background: true,
                    content: res.message || res.msg || "success",
                    duration: 5,
                  });
                }
              });
            },
            costFun({ searchForm }) {
              let ids = this.selectAll.map((item) => item.id);
              this.getModal("cost").id = ids[0];
              this.getModal("cost").update = false;
              this.getModal("cost").open({ ids }, function () {
                this.setTitle("costEntry");
              });
            },
            export({ searchForm }) {
              let obj = {
                export: 1,
                ...searchForm,
              };
              this.getModal("export").open(obj);
            },
            exportList({ searchForm }) {
              this.getModal("exportList").open({}, function () {
                this.getList();
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          minWidth: 180,
          fixed: "left",
          header: {
            copy: true,
          },
          copy: true,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            async click({ row }) {
              this.$page
                .getModal("detail")
                .setTitle(this.$t("detail") + `(${row.airway_number})`);
              this.$page.handleRequestMethods("detail", row.id).then((res) => {
                this.$page.temp = res.payload.total || {};
                this.$page.getModal("detail").open({ id: row.id }, function () {
                  this.id = row.id;
                  this.list = res.payload.rows;
                });
              });
            },
          },
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("mawb"),
          key: "extract_number",
          minWidth: 100,
        },
        {
          name: () => this.$t("Level_two") + this.$t("mawb"),
          key: "extract_number_sec",
          minWidth: 100,
        },
        {
          name: this.$t("order_refCode"),
          key: "agent_number",
          minWidth: 100,
        },
        {
          name: this.$t("clientName"),
          key: "customer",
          minWidth: 100,
        },
        {
          name: this.$t("mode"),
          key: "style",
          minWidth: 100,
        },
        {
          name: this.$t("company"),
          key: "service",
          minWidth: 100,
        },
        {
          name: this.$t("assistDepartment"),
          key: "department",
          minWidth: 100,
        },
        {
          name: () => this.$t("time"),
          children: [
            {
              name: () => this.$t("finances") + this.$t("time"),
              key: "finance_time",
              width: 110,
            },
            {
              name: () => this.$t("outbound_time"),
              key: "outbound_time",
              width: 110,
            },
            {
              name: () => this.$t("DEPARTURE_TIME"),
              key: "depart_time",
              width: 110,
            },
            {
              name: () => this.$t("arrival_date"),
              key: "arrival_time",
              width: 110,
            },
            {
              name: () => this.$t("pod_time"),
              key: "pod_time",
              width: 110,
            },
          ],
        },
        // {
        //   name: () => this.$t("ownership"),
        //   key: "ownership",
        //   align: "left",
        //   minWidth: 160,
        // },
        {
          name: () => this.$t("contract_title"),
          align: "left",
          key: "header_name",
          width: 110,
        },
        // {
        //   name: () => this.$t("salesman"),
        //   width: 95,
        //   key: "salesman",
        //   methods: {
        //     render: ({ row }) => {
        //       return row.clientInfo.salesman
        //         ? row.clientInfo.salesman.account
        //         : " - ";
        //     }
        //   }
        // },
        {
          name: () => this.$t("salesman"),
          key: "salesman_name",
          width: 95,
        },

        {
          name: this.$t("shipment_place"),
          key: "warehouse",
          minWidth: 100,
        },

        {
          name: () => this.$t("CTNS") + "(" + this.$t("case_number") + ")",
          key: "quantity",
          minWidth: 100,
        },
        {
          name: () => this.$t("unpack") + this.$t("noofpieces"),
          key: "unpack_num",
          minWidth: 100,
        },
        {
          name: this.$t("agentT"),
          children: [
            {
              name: () => this.$t("cross_port"),
              key: "hk_agent",
              minWidth: 100,
            },
            {
              name: () => this.$t("clearance"),
              key: "clearance_agent",
              minWidth: 100,
            },
            {
              name: () => this.$t("air_transport"),
              key: "air_agent",
              minWidth: 100,
            },
            {
              name: () => this.$t("delivery"),
              key: "delivery",
              minWidth: 100,
            },
            {
              name: () => this.$t("declareCustoms"),
              key: "baoguan_agent",
              minWidth: 100,
            },
            {
              name: () => this.$t("booking"),
              key: "dingcang_agent",
              minWidth: 100,
            },
            {
              name: () => this.$t("safetyAgent"),
              key: "safety_agent",
              minWidth: 100,
            },
            {
              name: () => this.$t("fileAgent"),
              key: "file_agent",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          width: 95,
        },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          width: 95,
        },
        {
          name: () => this.$t("allow_depart"),
          key: "from_country",
          width: 95,
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          width: 95,
        },
        {
          name: () => this.$t("destination"),
          key: "address",
          width: 95,
        },
        {
          name: () => this.$t("values"),
          key: "values",
          width: 100,
        },
        {
          name: () => this.$t("cod_amount1"),
          key: "cod_amount",
          width: 95,
        },
        {
          name: this.$t("invoiceWeight"),
          children: [
            {
              name: () => this.$t("check_weight"),
              key: "actual_weight",
              width: 95,
            },
            {
              name: () => this.$t("skuVolume"),
              key: "volume",
              width: 95,
            },
            {
              name: () => this.$t("charge_volume"),
              key: "volume_weight",
              width: 95,
            },
            {
              name: () => this.$t("charge_params"),
              key: "charge_weight",
              width: 95,
            },
          ],
        },
        {
          name: this.$t("deliveryCost_t"),
          children: [
            {
              name: () => this.$t("unapod"),
              key: "send_fee",
              minWidth: 110,
            },
            {
              name: () => this.$t("apod"),
              key: "pod_send_fee",
              minWidth: 110,
            },
          ],
        },
        {
          name: () => this.$t("cost_fee"),
          children: [
            {
              parentHeaderClass: "cost_fee",
              name: () => this.$t("packing_freight"),
              key: "cost1",
              minWidth: 110,
              // component: "Button",
              // bind: {
              //   type: "primary",
              //   size: "small"
              // },
              // methods: {
              //   click({ row }) {
              //     this.$page.getModal("feeModal").open({ row }, function() {
              //       this.setTitle(this.$t('freight_append')+"(" + row.airway_bill_number + ")");
              //       this.list = row.otherFeeItem;
              //     });
              //   }
              // }
            },
            {
              name: () => this.$t("air_freight"),
              key: "cost3",
              minWidth: 110,
            },
            {
              name: () => this.$t("sea_freight"),
              key: "cost4",
              minWidth: 110,
            },
            {
              name: () => this.$t("insurance_fee"),
              key: "cost8",
              minWidth: 110,
            },
            {
              name: () => this.$t("clearanceFee"),
              key: "cost5",
              minWidth: 110,
            },
            {
              name: () => this.$t("deliveryCost_t"),
              key: "cost6",
              minWidth: 110,
            },
            {
              name: () => this.$t("endTripFee"),
              key: "cost7",
              minWidth: 110,
            },
            {
              name: () => this.$t("car_rental"),
              key: "cost9",
              minWidth: 110,
            },
            {
              name: () => this.$t("customs_fee"),
              key: "cost2",
              minWidth: 110,
            },
            {
              name: () => this.$t("prepaid_fee"),
              key: "cost10",
              minWidth: 110,
            },
            {
              name: () => this.$t("RebatesRefundsDiscounts"),
              key: "cost11",
              minWidth: 110,
            },
            {
              name: () => this.$t("rateDiff"),
              key: "cost107",
              minWidth: 110,
            },
            {
              name: () => this.$t("cope") + this.$t("total"),
              key: "cost",
              minWidth: 110,
            },
          ],
        },
        {
          name: () => this.$t("income") + "(CNY)",
          key: "income",
          minWidth: 110,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          disabled({ row }) {
            return row.income <= 0;
          },
          methods: {
            async click({ row }) {
              this.$page
                .getModal("detail")
                .setTitle(
                  this.$t("income") +
                    this.$t("detail") +
                    `(${row.airway_number})`
                );
              this.$page
                .handleRequestMethods("income_details", row.id)
                .then((res) => {
                  this.$page.temp = res.payload.total || {};
                  this.$page
                    .getModal("detail")
                    .open({ income: 1 }, function () {
                      this.list = res.payload.rows;
                    });
                });
            },
          },
        },
        {
          name: () => this.$t("gross") + this.$t("profit") + "(CNY)",
          key: "profit",
          minWidth: 110,
        },
        {
          name: () => this.$t("gross") + this.$t("profit_rate"),
          key: "profit_rate",
          minWidth: 110,
        },
        {
          name: () => this.$tz("订单,备注"),
          key: "order_remarks",
          minWidth: 110,
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 110,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo") + this.$t("order_desc"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "success",
              },
              id: 1189,
            },
            {
              name: () => this.$tz("CNB,详情"),
              type: "unpack_order",
              fnName: "unpack_order",
              bind: {
                type: "primary",
              },
              show: ({ row }) => row.is_unpack == 1,
              // id: 1189,
            },
          ],
          methods: {
            unpack_order({ row }) {
              this.handleRequestMethods("unpack_order", row.id).then((res) => {
                this.getModal("unpack_order").open({}, function () {
                  this.setTitle(
                    `${this.$tz("CNB,详情")}(${row.airway_number})`
                  );
                  this.list = res.payload.rows;
                });
              });
            },
            addFun({ row }) {
              this.getModal("remark").open(
                { id: row.id, remarks: row.remarks },
                function () {
                  this.setTitle(this.$t("addTo") + this.$t("order_desc"));
                }
              );
            },
          },
        },
      ],
    };
  },
  async mounted() {
    setTimeout(() => {
      this.$refs["table"].getTable().scrollTo(4140, 0);
    }, 100);
    let searchData = (await getConfig()).data.payload;
    let agentData = await getAgent();
    this.header.searchs.forEach((item) => {
      if (item.key === "business") item.options = searchData["5"];
      if (item.key === "agent_id") item.options = agentData.data.payload.rows;
    });
  },
};
</script>
<style>
.cost_fee {
  border: 0.5px solid #ebd0bd;
}
.vxe-body--column.col-red {
  background-color: red;
  color: #fff;
}
</style>
